export class MapColours {
	/*
	 * Init the handler
	 *
	 */
	constructor() {
		const colours = {
			arcPurple: {
				primary: '#A599D8',
				secondary: '#8062F8',
				tertiary: '#6D49FF',
				text: '#ffffff',
			},
			arcPink: {
				primary: '#ECBAA8',
				secondary: '#F2D0C3',
				tertiary: '#D7AEA0',
				text: '#000000',
			},
			arcBlue: {
				primary: '#63b5e5',
				secondary: '#78d5e1',
				tertiary: '#1da2b9',
				text: '#000000',
			},
			arcOrange: {
				primary: '#EDA688',
				secondary: '#F08D63',
				tertiary: '#FC4C02',
				text: '#ffffff',
			},
			arcBrown: {
				primary: '#8E6C46',
				secondary: '#927F69',
				tertiary: '#786249',
				text: '#ffffff',
			},
			arcGrey: {
				primary: '#D9D9D6',
				secondary: '#C1C1C1',
				tertiary: '#AFAFAF',
				text: '#000000',
			},
		};
        return colours;
	}
}
